/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StationAvailabilitiesDurationsList } from '../../models/station-availabilities-durations-list';

export interface GetAvailabilitiesDurations$Params {

/**
 * The date of stations daily availabilities to filter
 */
  date: string;
}

export function getAvailabilitiesDurations(http: HttpClient, rootUrl: string, params: GetAvailabilitiesDurations$Params, context?: HttpContext): Observable<StrictHttpResponse<StationAvailabilitiesDurationsList>> {
  const rb = new RequestBuilder(rootUrl, getAvailabilitiesDurations.PATH, 'get');
  if (params) {
    rb.query('date', params.date, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StationAvailabilitiesDurationsList>;
    })
  );
}

getAvailabilitiesDurations.PATH = '/custom/stations/availabilities/durations';
